// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

// Use the correct WebSocket URL with protocol and host
const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const host = window.location.host;

// Create a default consumer with no token
// This will be used as a fallback if createConsumerWithToken is not called
const consumer = createConsumer(`${protocol}//${host}/cable`);

// Function to create a consumer with a token
// This should be called from the view with the token generated in Rails
export function createConsumerWithToken(token) {
  if (!token) return consumer;

  // Add the token as a query parameter to the URL
  // This is necessary because createConsumer doesn't support options
  const url = `${protocol}//${host}/cable?token=${encodeURIComponent(token)}`;

  // Create a new consumer with the token in the URL
  return createConsumer(url);
}

export default consumer;
